(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.videosingle = videosingle;
function videosingle() {
  // // GLOBAL SCOPE FOR YOUTUBE
  // GLOBAL STATE
  window.ytPlayerSingle = null;
  window.ytPlayerSingleReady = false;

  //YOUTUBE API
  // GLOBAL SCOPE
  var youtubeApiLoading = false;
  var youtubeApiLoaded = false;
  var ytAPIPromise = void 0;
  function loadYouTubeAPISingle() {
    if (window.YT?.Player) {
      return Promise.resolve();
    }
    if (ytAPIPromise) {
      return ytAPIPromise;
    }
    ytAPIPromise = new Promise(function (resolve) {
      var existingScript = document.querySelector('script[src="https://www.youtube.com/iframe_api"]');
      if (!existingScript) {
        var tag = document.createElement('script');
        tag.src = 'https://www.youtube.com/iframe_api';
        document.head.appendChild(tag);
      }
      var check = setInterval(function () {
        if (window.YT?.Player) {
          clearInterval(check);
          resolve();
        }
      }, 50);
    });
    return ytAPIPromise;
  }
  function initPlayerSingle(videoId) {
    return loadYouTubeAPISingle().then(function () {
      if (!window.ytPlayerSingle) {
        window.ytPlayerSingle = new YT.Player('single-video', {
          videoId: videoId,
          playerVars: {
            autoplay: 1,
            controls: 1,
            rel: 0,
            modestbranding: 1
          }
        });
      } else {
        window.ytPlayerSingle.loadVideoById(videoId);
      }
    });
  }
  //YOUTUBE API

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('#single-video-play');
    origin = btn;
    if (!btn) return; // click was not on a video-button

    e.preventDefault();
    //const transcriptLink = document.getElementById('youtube-video-transcript');
    var videoId = btn.getAttribute('data-video');
    //const transcript = btn.getAttribute('data-transcript');
    //transcriptLink.setAttribute('href', transcript);
    //transcriptLink.style.display = transcript ? 'inline-block' : 'none';

    if (!videoId) return;

    //overlay.classList.add('active');

    initPlayerSingle(videoId).then(function () {
      //closeVideo.focus();
    });
  });
}

},{}],2:[function(require,module,exports){
"use strict";

var _videoSingle = require("./parts/video-single.js");
window.addEventListener("load", function (event) {
  (0, _videoSingle.videosingle)();
});

},{"./parts/video-single.js":1}]},{},[2]);
